import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-refunds-policy',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './refunds-policy.component.html',
  styleUrls: ['./refunds-policy.component.scss']
})
export class RefundsPolicyComponent {
  getCurrentDate(): string {
    return new Date().toLocaleDateString('en-IN', { timeZone: 'Asia/Kolkata' });
  }
}